/**
 * Shared motion primitives for all tg_game Mini Apps.
 * Motion conveys state, never decoration; everything here respects
 * `prefers-reduced-motion` (falls back to instant updates).
 *
 * NOTE: this file must stay framework-agnostic. `web/shared` sits outside
 * each app's node_modules resolution path, so importing 'react' here breaks
 * `tsc -b` in the apps. Hooks live in each app's src/useCountUp.ts.
 */

/** Brand ease-out (expo-ish). Matches --ease-out in each app's index.css. */
export const EASE_OUT = [0.16, 1, 0.3, 1] as const

/** Controlled acceleration for anticipation and physically weighted travel. */
export const EASE_IN = [0.55, 0.06, 0.68, 0.19] as const

/** Neutral cinematic timing for state-to-state movement. */
export const EASE_STANDARD = [0.4, 0, 0.2, 1] as const

/** Spring presets for framer-motion transitions. */
export const SPRING_POP = { type: 'spring', stiffness: 420, damping: 30 } as const
export const SPRING_SOFT = { type: 'spring', stiffness: 260, damping: 26 } as const
export const SPRING_SETTLE = {
  type: 'spring',
  stiffness: 310,
  damping: 34,
  mass: 0.82,
} as const

export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}

/** easeOutCubic — shared by count-up hooks and canvas tweens. */
export function easeOutCubic(p: number): number {
  return 1 - Math.pow(1 - p, 3)
}
